import { GridColDef, GridRowModel } from "@mui/x-data-grid"
import { Header, TableStandard } from "ui"
import { useEffect, useState } from "react"
import { splitCamelCase } from "../../tools/splitCamelCase"
import { CompanySessionStats } from "../../__generated__/graphql"
import { Typography, Box } from "@mui/material"
const TABLE_COLUMNS: GridColDef[] = [
    {
        field: "color", headerName: "Color Code", flex: 1, sortable: false, resizable: false, disableColumnMenu: true,
        renderCell: ({ value }) => (
            <Box sx={{
                backgroundColor: value,
                width: "100%",
                height: "100%",
                borderRadius: 1
            }} />
        )
    },
    { field: "disposition", headerName: "Disposition", flex: 3, sortable: false, resizable: false, disableColumnMenu: true, },
    { field: "count", headerName: "Count", headerAlign: "center", align: "center", flex: 1, sortable: false, resizable: false, disableColumnMenu: true, },
]
type DispositionKey = keyof CompanySessionStats;
const allowedFields: DispositionKey[] = ["crisisSupportIndicated", "intensiveSupportIndicated", "supportIndicated", "preventionAndStrengthIndicated"]
const mappedColors = {
    "crisisSupportIndicated": "#F4CCCC",
    "intensiveSupportIndicated": "#FCE5CD",
    "supportIndicated": "#FFF2CC",
    "preventionAndStrengthIndicated": "#D9EAD3"
} as const
const DispositionTable = ({ dispositionCount }: { dispositionCount: CompanySessionStats | null }) => {
    const [pageTableState, setPageTableState] = useState<{
        columns: GridColDef[],
        rows: GridRowModel[],
        filteredRows: GridRowModel[]
        status: "NORMAL" | "FILTERING"
    }>({
        columns: [],
        rows: [],
        filteredRows: [],
        status: "NORMAL"
    })
    useEffect(() => {
        setPageTableState((prevState) => {
            const columns = [...TABLE_COLUMNS]
            const rows = dispositionCount
                ? allowedFields.map(key => ({
                    id: key,
                    color: mappedColors[key as keyof typeof mappedColors],
                    disposition: splitCamelCase(key),
                    count: dispositionCount[key]
                }))
                : [];

            return {
                ...prevState,
                columns,
                rows: rows
            }
        })
    }, [dispositionCount])
    return (
        <TableStandard
            renderToolbar={() => (
                <Header title={`Disposition `} titleSize="p" />
            )}
            columns={pageTableState.columns}
            rows={pageTableState.rows}
            disableBoxShadow
            hideFooter={true}
            loading={false} />
    )
}
export default DispositionTable